import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { EtapaEnvioViewDTO } from './types'

const getEndpoint = (url = '') => `etapa-envio-mail-extra${url}`

export const HttpEtapaEnvioMail = {
    getByTipoSistema: (tinCodSistemaTipo: number, sinCodPais?: number): Promise<EtapaEnvioViewDTO[]> =>
        HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(), {
            tinCodSistemaTipo,
            ...(sinCodPais ? { sinCodPais } : {})
        }),

    updateGrupos: (sinCodSistema: number, intIdEtapa: number, idsGrupo: number[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/${sinCodSistema}/${intIdEtapa}/grupos`), idsGrupo)
}
